$(document).ready(function () {
    if ($('.basket-standard').length) {
        window.history.replaceState(
            {},
            document.title,
            window.location.origin + window.location.pathname
        );
    }
});

// Aimeos core's AJAX submit handler (aimeos.js AimeosBasketStandard.setupUpdateSubmit) posts
// to the form's own "action" and ignores which submit button (with its own "formaction",
// e.g. delete/remove) triggered the submit. Runs in the capture phase so it corrects the
// form's action before that handler reads it. Works for real clicks and for JS-triggered
// clicks on the button (SubmitEvent.submitter is set either way); only a raw form.submit()
// call bypasses it, and nothing in this codebase does that on the basket form.
document.addEventListener(
    'submit',
    function (ev) {
        var form = ev.target;
        if (
            !(form instanceof HTMLFormElement) ||
            !form.matches('.basket-standard form')
        ) {
            return;
        }

        var submitter = ev.submitter;
        if (submitter && submitter.formAction) {
            form.setAttribute('action', submitter.formAction);
        }
    },
    true
);
